import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import styled from 'foundations-theming/utils';
import { useAppSelector } from '../../../reducers';
import { billingNameKeySelector, skuIdHasBundledProductsSelector } from '../../../selectors/ProductsSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BundleContent = styled.div.withConfig({
  displayName: "BundleIncludesDisplay__BundleContent"
})(({
  theme
}) => ({
  '& strong': {
    marginTop: theme.space['300'],
    display: 'inline-block'
  }
}));
export const BundleIncludesDisplay = ({
  skuId
}) => {
  const hasBundles = useAppSelector(state => {
    return skuIdHasBundledProductsSelector(state, {
      skuId
    });
  });
  const billingNameKey = useAppSelector(state => billingNameKeySelector(state, {
    skuId
  }));
  if (!hasBundles) {
    return null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(View, {
      marginBlockStart: "100",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "planBuilder.includes"
      })
    }), /*#__PURE__*/_jsx(View, {
      marginInlineStart: "500",
      display: "inline-block",
      children: /*#__PURE__*/_jsx(BundleContent, {
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: `pricing-pages-ui.productNamesV2.${billingNameKey}.bundleIncludes`
        })
      })
    })]
  });
};